import * as actions from '../utils/Constants';

export const clearNewUser = () => {
    return { type: actions.CLEAR_NEW_USER };
}

export const createUser = (credentials) => {

    return {
        type: actions.SAVE_NEW_USER,
        payload: fetch(process.env.REACT_APP_API_HOST + `api/user/new`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(credentials),
        }).then(res => {
            return res.json();
        }).catch(error => {
            return Promise.reject(error);
        })
    }
}